import React, {useEffect} from 'react';
import {Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {connect} from 'react-redux';
import {useHistory} from "react-router-dom"
import * as actionTypes from '../../../redux/constants';
import sessionTimer from "../../../common/sessionTimeout";

const LOGOUT_TIMER = 5 * 60 * 1000;

let LOGOUT_TIMER_ID = null;

const SessionTimeoutModal = (props) => {

    useEffect(() => {
        if (!props.showSessionTimeoutModal) return;

        LOGOUT_TIMER_ID = setTimeout(() => {
            props.clearUserData();
            props.clearSessionTimeoutModal();

            history.push('/');
        }, LOGOUT_TIMER);

    }, [props.showSessionTimeoutModal]);

    const {t} = useTranslation();

    let history = useHistory();

    const logoutUser = () => {
        props.clearUserData();
        props.clearSessionTimeoutModal();

        history.push('/');
    };

    return (
        <Dialog
            open={props.showSessionTimeoutModal}
        >
            <DialogTitle id={'error-dialog'} color={'primary'}>{t('Global.session_timeout')}</DialogTitle>
            <DialogContent>
                <Typography control={'p'} variant={'body1'} color={'validation'}>
                    {t('Global.session_timeout_message')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    color={'secondary'}
                    variant={'contained'}
                    onClick={() => {
                        logoutUser();
                    }}
                >
                    {t('Global.session_logout')}
                </Button>
                <Button
                    color={'primary'}
                    variant={'contained'}
                    onClick={() => {
                        clearTimeout(LOGOUT_TIMER_ID);
                        sessionTimer.reset();
                        props.clearSessionTimeoutModal();
                    }}
                >
                    {t('Global.session_keep_working')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        showSessionTimeoutModal: state.uxStateReducer.get("showSessionTimeoutModal")
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearUserData: () => dispatch({
            type: actionTypes.CLEAR_CURRENT_USER_DATA
        }),
        clearSessionTimeoutModal: () => dispatch({
            type: actionTypes.HIDE_TIMEOUT_MODAL
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeoutModal);